import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { apiRequest } from '../reducers/data'

const Choices = [
  {
    name: 'Very Light',
    score: '(6-10)',
    color: '#222',
  },
  {
    name: 'LIGHT',
    score: '(11-12)',
    color: 'green',
  },
  {
    name: 'SOMEWHAT hard',
    score: '(13-14)',
    color: 'green',
  },
  {
    name: 'Hard or heavy',
    score: '(15-16)',
    color: 'red',
  },
  {
    name: 'EXTREMELY Hard',
    score: '(17-20)',
    color: 'red',
  },
]

const SubmitRPEContainer = (props) => {
  const [chosen, setChosen] = useState(0)
  const [saving, setSaving] = useState(false)

  const history = useHistory()

  const onSubmitRating = async () => {
    const start = Date.now()
    setSaving(true)
    await window.store.dispatch(apiRequest(['me', 'rpe-rating'], 'POST', { rating: chosen }))
    setTimeout(() => {
      setSaving(false)
      history.push('/mobile/videos')
    }, Math.max(0, 400 - (Date.now() - start)))
  }

  return (
    <div
      className="screen rpe"
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
      }}
    >
      <div className="navigation-bar">
        <div className="title">Rate your activity</div>
      </div>
      <div style={{ height: 15 }} />
      <h3>How'd it feel?</h3>
      Choose one of the options below that describes the intensity of your last activity.
      <div className="rpe-options">
        {Choices.map((c, idx) => (
          <div
            className={`rpe-option ${idx + 1 === chosen && 'active'}`}
            onClick={() => setChosen(idx + 1)}
            key={'choices_' + idx}
          >
            <img src={require(`../images/difficulty_${idx + 1}.png`)} alt={c.name} />
            <div>
              {c.name}
              <span style={{ fontWeight: 500, color: c.color }}>{c.score}</span>
            </div>
          </div>
        ))}
      </div>
      <div style={{ flex: 1 }} />
      <button className="black block" onClick={() => onSubmitRating()}>
        {saving ? `Saving...` : `Save Rating`}
      </button>
    </div>
  )
}

export default SubmitRPEContainer
